<template>
  <div @click="handleSelectProduct(product)" class="my-2 lg:my-0 cursor-pointer transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col border border-solid" :class="[isSelectedProduct ? 'border-black' : 'border-gray-200']">
    <div class="flex-1">
      <h3 class="text-xl font-semibold text-gray-900 h-16">{{ product.name.toUpperCase() }}</h3>
      <div class="mt-0 flex flex-col items-baseline text-gray-900 leading-9">
        <span :class="['tracking-tight', product.displayDiscount ? 'text-decoration-line: line-through text-xl text-gray-300 font-bold' : 'text-5xl text-gray-900 font-extrabold']">${{ product.price }}</span>
        <span v-if="product.displayDiscount" class="text-5xl font-extrabold tracking-tight">${{ product.discountedPrice }}</span>
      </div>

      <!-- Feature list -->
      <ul role="list" class="mt-0 lg:mt-4 mb-2 space-y-6">
        <li class="flex">
          <span class="text-gray-500">{{ product.description }}</span>
        </li>
      </ul>
    </div>
    <button :class="[('mt-0 lg:mt-3 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium '), (isSelectedProduct ? 'bg-brand-primary text-white' : 'bg-brand-primary-light hover:bg-brand-primary text-brand-secondary')]">{{ isSelectedProduct ? 'Selected' : 'Select Product'}}</button>
  </div>
</template>

<script setup lang='ts'>
import { defineProps, defineEmits } from 'vue';
import HardwareImage from './HardwareImage.vue';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
}

defineProps<{
  isSelectedProduct: boolean
  product: Product
}>();

const emit = defineEmits<{(event: 'handle-select-product', product: Product): void}>();

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};
</script>
